import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";
import injectSaga from "../../../utils/injectSaga";
import injectReducer from "../../../utils/injectReducer";
import reducer from "../../../containers/PlpContainer/reducer";
import saga from "../../../containers/PlpContainer/saga";
import * as actionCreators from "../../../containers/PlpContainer/actions";
import { getReleventReduxState, isMobile } from "../../../utils/utilityManager";
import { imagePrefix } from "../../../../public/constants/constants";
import { filter } from "lodash";
import { triggerPlpFilterEvent } from "../../../utils/gtm";

// const downArrow = (
//   <img
//     className="dropdownArrow"
//     src={`${imagePrefix}/B2C/static/plpAssests/drop-down-arrow-down.svg`}
//     alt="Down"
//   />
// );
// const upArrow = (
//   <img
//     className="dropdownArrow"
//     src={`${imagePrefix}/B2C/static/plpAssests/drop-down-arrow-up.svg`}
//     alt="Up"
//   />
// );

class Filter extends React.Component {
  constructor() {
    super();
    this.state = {
      selected: 0,
      options: ["recommended", "price_L_H", "price_H_L", "newArrival"],
      facetItem: null,
      facetArr: [],
      checked: false,
      isMobile: window.innerWidth <= 760,
      isRWDFilterSelected: false,
      active: false,
      selectedL2: "",
      RWDSelected: []
    };
    this.toggleDropdown = this.toggleDropdown.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
    this.onCheckBoxClick = this.onCheckBoxClick.bind(this);
    this.onCancelBtnClick = this.onCancelBtnClick.bind(this);
    this.onApplyBtnClick = this.onApplyBtnClick.bind(this);
  }

  toggleDropdownDesktop(eleId) {
    let val = eleId;

    if (this.state.selectedL2 === eleId) {
      val = "";
    }
    this.setState({
      selectedL2: val,
    });
  }

  toggleDropdown(ismmm) {
    if (!this.state.active) {
      this.props.updateCurrentFacetSelection(this.props.dataPro.facetName);
    }

    if (!this.state.active) {
      document.addEventListener("click", this.handleOutsideClick, false);
      if (isMobile()) {
        this.state.facetArr = [];
        this.resolvePreSelectedFilters();
      }
    } else {
      document.removeEventListener("click", this.handleOutsideClick, false);
    }

    this.unCkeckAll();
    [
      ...document.getElementsByClassName(
        `checkboxSelected${this.props.dataPro.facetName}`
      ),
    ].map(input => {
      input.checked = "checked";
    });

    const filteredArr = [];
    let preFilter = this.props.updatedFilter;
    if (isMobile()) {
      preFilter = this.props.RWDupdatedFilter;
    }
    for (const [key, value] of preFilter) {
      if (key === this.props.dataPro.facetName) {
        value.map((option, i) => {
          filteredArr.push(option);
        });
      }
    }

    // this.setState({facetArr: filteredArr})

    this.setState({
      active: !this.state.active,
      facetArr: filteredArr,
    });
  }

  handleOutsideClick(e) {
    if (this.node && this.node.contains(e.target)) {
      return;
    }
    this.toggleDropdown();
  }

  
  onCheckBoxClick(index) {
    console.log('selectedFacet in onCheckBoxClick = '+JSON.stringify(this.props.dataPro.facetName));
    console.log('selectedFacet in onCheckBoxClick = '+JSON.stringify(this.props.dataPro.facetValues[index]));
    triggerPlpFilterEvent(this.props.dataPro.facetName,this.props.dataPro.facetValues[index]);
    const selectedFacet = this.props.dataPro.facetValues[index];
    let filteredArr = [...this.state.facetArr];
    if(isMobile()){
      this.props.updateFilterNumber(
        this.props.dataPro.facetValues[index].label
      );
    }
      const extFacetArr = this.state.facetArr.map(item =>  item.value.replace(/\%2B/g, "+"));
      if (!extFacetArr.includes(selectedFacet.value)) {
        filteredArr.push(selectedFacet);
      } else {
        filteredArr = this.state.facetArr.filter((value, i, arr) => {
          if (value.value.replace(/\%2B/g, "+") != selectedFacet.value) {
            return value;
          }
        });
      }
    // }
    
    const params = new URLSearchParams(this.props.location.search);

    this.setState({ facetArr: filteredArr }, () => {
      if (!isMobile()) {
        this.onApplyBtnClick();
        const elmnt = document.getElementById("desktop-sort");
        elmnt.scrollIntoView();
      }
    });

    if (isMobile()) {
      this.state.facetArr = filteredArr;
      this.props.onRWDFilterUpdate(
        this.state.facetArr,
        this.props.dataPro.facetName,
        false
      );

      const staticFilterArr = [];
      this.state.facetArr.map(data => {
        staticFilterArr.push(data.value);
      });

      this.filterOptions(staticFilterArr);
      if (filteredArr.length !== 0) {
        this.setState({
          isRWDFilterSelected: true,
        },()=>{ this.onApplyBtnClick()});
      } else {
        this.setState({
          isRWDFilterSelected: false,
        },()=>{ this.onApplyBtnClick()});
      }
    }
  
    // this.resolvePreSelectedFilters();
    // this.setupAppliedFilterData()
    
  }

  onLabelClick(ref) {
    // alert("aaa");
  }

  onFacetChange(isToggle) {
    if (isToggle) {
      this.toggleDropdown(true);
    }

    if (this.props.onFacetChangePro) {
      this.props.onFacetChangePro((err, res) => {
        if (res) {
          this.unCkeckAll();

          const filteredArr = [...this.state.facetArr];
          const preFilter = this.props.RWDupdatedFilter;
          for (const [key, value] of preFilter) {
            if (key === this.props.dataPro.facetName) {
              value.map((option, i) => {
                filteredArr.push(option);
              });
            }
          }

          const extFacetArr = filteredArr.map(item =>
            item.value.replace(/\%2B/g, "+")
          );
          this.filterOptions(extFacetArr);

          // this.filterOptions([]);
        }
      });
    }
  }

  onCancelBtnClick() {
    this.toggleDropdown();
    if (this.props.isFromRWD) {
      this.props.rwdFilterCallbackPro();
      this.props.onRWDFilterCancel();
    }
  }

  onApplyBtnClick() {
    this.state.facetArr.map(item => {
      item.value = item.value.replace(/\+/g, "%2B");
    });

    if (isMobile()) {
      this.props.onRWDFilterUpdate(
        this.state.facetArr,
        this.props.dataPro.facetName,
        true
      );
      if (
        !this.compareMaps(this.props.RWDupdatedFilter, this.props.updatedFilter)
      ) {
        // this.onCancelBtnClick();
      }
    } else {
      // alert("yup");
      this.props.onFilterUpdate(
        this.state.facetArr,
        this.props.dataPro.facetName
      );
    }
  }

  compareMaps(map1, map2) {
    let testVal;
    if (map1.size !== map2.size) {
      return false;
    }
    for (const [key, val] of map1) {
      testVal = map2.get(key);
      // in cases of an undefined value, make sure the key
      // actually exists on the object so there are no false positives
      if (testVal !== val) {
        return false;
      }
      if (testVal === undefined) {
        return false;
      }
      if (!map2.has(key)) {
        return false;
      }
    }
    return true;
  }

  unCkeckAll() {
    [
      ...document.getElementsByClassName(
        `checkbox${this.props.dataPro.facetName}`
      ),
    ].map(input => {
      if (input.checked) {
        input.checked = !input.checked;
      }
      return null;
    });
  }

  directFilterLink(params){
    let filterValues= []
    for (const pair of params.entries()) {
      filterValues =pair[1].split('facet=').filter(elm => elm)
    }
   
    filterValues.map((filterval,index)=>{
      filterval = filterval.split('&')[0]
      this.props.dataPro.facetValues.map((facet,indexMain)=>{
        if(filterval == encodeURI(facet.value.replace(/\+/g, "%2B"))){
          // this.onCheckBoxClick(indexMain)
        }
      })
    })
  }

  componentDidMount() {
    const windowUrl = window.location.search;
    const params = new URLSearchParams(windowUrl);
    if(params.has('filter')){
      this.directFilterLink(params)
    }
    if (!isMobile()) {
      this.toggleDropdownDesktop(this.props.dataPro.facetName);
    }
    if (this.props.indexPro === 0 && isMobile()) this.toggleDropdown(true);
    this.resolvePreSelectedFilters();
    this.setupAppliedFilterData()
  // document.getElementById('RWD-ClearALL').addEventListener('click', this.onApplyBtnClick(), false )
  }
  

  componentWillReceiveProps(nextProps) {
  //  console.log(nextProps)
    if (isMobile()) {
      this.unCkeckAll();
      if (nextProps.resetCurrentSelection) {
        this.onFacetChange(true);
        this.setState({
          facetArr: [],
          facetItem: [],
        });
        this.props.onResetCurrentlFilter();
      }

      if (nextProps.RWDupdatedFilter !== this.props.RWDupdatedFilter) {
        this.filterOptions([]);
        this.setupAppliedFilterData()
      }
    }
  }

  resolvePreSelectedFilters() {
    const alreadyAddedFiltersArr = [];
    const filteredArr = [...this.state.facetArr];
    let preFilter = this.props.updatedFilter;
    if (isMobile()) {
      preFilter = this.props.RWDupdatedFilter;
    }
    for (const [key, value] of preFilter) {
      if (key === this.props.dataPro.facetName) {
        value.map((option, i) => {
          filteredArr.push(option);
          alreadyAddedFiltersArr.push(option);
        });
      }
    }
    this.setState({
      facetArr: filteredArr,
      active:
        this.props.fetchCurrentFacetSelection() ===
          this.props.dataPro.facetName && this.props.isFromRWD
          ? !this.state.active
          : false,
    });
    const extFacetArr = filteredArr.map(item =>
      item.value.replace(/\%2B/g, "+")
    );
    this.filterOptions(extFacetArr);
  }

  filterOptions(alreadyAddedFiltersArr) {
    if (isMobile()) {
      this.setState({
        facetItem: null,
        isRWDFilterSelected: null,
      });
    }

    let isRWDFacetSelecte = false;
    const item = this.props.dataPro.facetValues.map((option, i) => {
      let checkboxItem;
      let customSelectionBoxId;
      const reference = React.createRef();
      if (alreadyAddedFiltersArr.includes(option.value)) {
        customSelectionBoxId = `selected_${this.props.dataPro.facetName}${i}`;
        checkboxItem = (
          <input
            className={`inputCheck checkboxSelected${
              this.props.dataPro.facetName
            }`}
            onChange={evt => this.onCheckBoxClick(i)}
            defaultChecked
            type="checkbox"
            ref={reference}
            id={customSelectionBoxId}
            name="scales"
          />
        );
        isRWDFacetSelecte = true;
      } else {
        customSelectionBoxId = this.props.dataPro.facetName + i;
        checkboxItem = (
          <input
            className={`inputCheck checkbox${this.props.dataPro.facetName}`}
            onChange={evt => this.onCheckBoxClick(i)}
            type="checkbox"
            id={customSelectionBoxId}
            name="scales"
            ref={reference}
            disabled={option.count === 0}
          />
        );
      }

      let checkItem;

      let colorStyle = {
        display: "block",
        // display:'inline-block',
      };
      let imgUrl = null;
      let colorRGBClass;
      let customCheckItem;

      if (option.colorCode) {
        colorRGBClass = "circleRGB";
        colorStyle = { backgroundColor: `rgb${option.colorCode}` };
        customCheckItem = (
          <div className="circlebox">
            <span className={colorRGBClass} style={colorStyle} />
          </div>
        );
        checkItem = (
          <label className="lblradio" htmlFor={customSelectionBoxId}>
            {customCheckItem}
          </label>
        );
      } else if (option.facetImage) {
        colorRGBClass = "circleRGB";
        imgUrl = `${imagePrefix}${option.facetImage}`;
        customCheckItem = (
          <div className="circlebox">
            <img className={colorRGBClass} style={colorStyle} src={imgUrl} />
          </div>
        );
        checkItem = (
          <label className="lblradio" htmlFor={customSelectionBoxId}>
            {customCheckItem}
          </label>
        );
      } else {
        checkItem = (
          <label className="lblCheck" htmlFor={customSelectionBoxId} />
        );
      }

      return (
        <>
          {option.count == 0 && this.props.dataPro.facetName == "Price" ? (
            <></>
          ) : (
            <li
              key={i}
              className={
                option.colorCode || option.facetImage
                  ? "list checkboxPrimary"
                  : "list"
              }
            >
              <div
                key={i}
                className={`dropdown__list-item ${
                  i === this.state.selected ? "dropdown__list-item--active" : ""
                }`}
              >
                <div className="input_box input_box1">
                  {checkboxItem}
                  {/* actual checkbox item desktop */}
                  {checkItem}
                </div>

                {!isMobile() ? (
                  <div
                    className={
                      option.count === 0
                        ? "label_text label_text_disable"
                        : "label_text"
                    }
                  >
                    <span className="filter-nametext">{`${option.label}`}
                      {this.props.dataPro.facetName == "Discount" ? <>%</> : <></>}
                    </span>
                    {this.props.dataPro.facetName.toLowerCase() == "primary color" || this.props.dataPro.facetName.toLowerCase() == "ribbon" ? (
                      <></>
                    ) : (
                      <span className="filter-count">{`${option.count}`}</span>
                    )}
                  </div>
                ) : (
                  <div
                    className={
                      option.count === 0
                        ? "label_text label_text_disable"
                        : "label_text"
                    }
                    onClick={() => {
                      if (option.count !== 0) {
                        reference.current.checked = !reference.current.checked;
                        this.onCheckBoxClick(i);
                      }
                    }}
                  >
                    {option.label}
                    {this.props.dataPro.facetName == "Discount" ? <>%</> : <></>}
                    <span className="filterCount"> {option.count}</span>
                  </div>
                )}
              </div>
            </li>
          )}
        </>
      );
    });
    if (isMobile) {
      const lastItem = <li className="emptylist" />;
      item.push(lastItem);
    }
    this.setState({
      facetItem: item,
      isRWDFilterSelected: isRWDFacetSelecte,
    });
  }

  setupAppliedFilterData(){
    if(this.props.RWDupdatedFilter.size>0){
      let appliedFilltersArr = []
      for (const [key, value] of this.props.RWDupdatedFilter) {
        value.map((option, i) => {
          let isThere = false;
          for (const item of this.props.allFilters) {
            const isFound = item.facetValues.filter(
              e => e.label === option.label
            );
            if (isFound.length > 0) isThere = true;
          }
          if (isThere === true) appliedFilltersArr.push(option);
          else {
            // this.clearTheSelectedFilterValue(option.value);
          }
        });
      }
      // console.log(appliedFilltersArr)
      this.setState({
        RWDSelected: appliedFilltersArr
      })
    }
  }





  resolveRWDselectedFilter=(e)=>{
    this.props.dataPro.facetValues.map((filter,key)=>{
      // console.log("loop: " + filter.value.replaceAll("+",'%2B' ) + 'selected: ' + e.target.getAttribute('value'))
      if(e.target.getAttribute('value') == filter.value.replaceAll("+",'%2B' ) || e.target.getAttribute('value') == filter.value){
        // console.log('got it')
        this.onCheckBoxClick(key)
      }
    })
    let data = []
    this.state.RWDSelected.map((filter,key)=>{
      if(filter.value != e.target.getAttribute('value')){
        data.push(filter)
      }
    })
    this.setState({
      RWDSelected: data
    })
  }

  // shouldComponentUpdate(nextProps, nextState){
  //   if(nextProps == this.props && nextState == this.state){
  //     return false
  //   }
  //   else{
  //     return true
  //   }
  // }

  render() {
    // console.log("heree: " + JSON.stringify(this.props.dataPro, null, 2));
    return (
      <>
        <div
          ref={node => {
            this.node = node;
          }}
          className="dropdown_filter"
        >
          <div
            className={
              isMobile()
                ? "dropdown_filter__filter"
                : "dropdown_filter__filter toggleFilter"
            }
            onClick={() =>
              this.toggleDropdownDesktop(this.props.dataPro.facetName)
            }
          >
            <div
              className="dropdown_filter__toggle dropdown_filter__list-item"
              onClick={
                this.props.isFromRWD
                  ? this.state.active
                    ? () => {
                      this.onFacetChange(false);
                    }
                    : () => {
                      this.onFacetChange(true);
                    }
                  : () => {
                    this.toggleDropdown(true);
                  }
              }
            >
              <div className="toggleMenu_text">
                <span>
                  <b>{this.props.dataPro.facetName}</b>
                </span>
                {!isMobile() && (
                  <div
                    className={
                      this.state.selectedL2 === this.props.dataPro.facetName
                        ? "signArrow_filter arrowOpen_filter"
                        : "signArrow_filter arrowClosed_filter"
                    }
                  />
                )}
              </div>

              {/* left panel name */}
              {this.props.isFromRWD ? (
                this.state.isRWDFilterSelected ? (
                  <div className="selectedFacet">•</div>
                ) : null
              ) : null}
              {/* {this.props.isFromRWD
                ? null
                : this.state.active
                  ? upArrow
                  : downArrow} */}
            </div>
          </div>

          {!isMobile() && (
            <ul
              className={`dropdown_filter__list dropdown_filter__list-new ${
                this.state.active ? "dropdown_filter__list--active" : ""
              } ${
                this.state.selectedL2 === this.props.dataPro.facetName
                  ? "toggleFilterItems"
                  : "toggleFilterItems open"
              } `}
            >
              <div
                className={`filter_hidden ${
                  this.state.selectedL2 === this.props.dataPro.facetName
                    ? "filter-toggle open"
                    : "filter-toggle "
                }`}
              >
                {this.state.facetItem}

                {/* <div className="clearfix" />
                <div className="filterbtnWrapper">
                  <button
                    disabled={this.props.clearStatus}
                    onClick={() =>
                      this.props.clearSelectedFacet(this.props.dataPro)
                    }
                    className=" clearTxt clearTxtNew"
                  >
                    Clear
                  </button> */}
                {/* <button
                    onClick={() => this.onApplyBtnClick()}
                    className="dropdown_filter__applyBtn btn"
                  >
                    APPLY here
                  </button> */}
                {/* </div> */}
              </div>
            </ul>
          )}

          {isMobile() && (
            <div className="filter-data-list">
              <ul
                // changes
                id={this.props.dataPro.facetName === "Price" 
                || this.props.dataPro.facetName ==='Primary Material' 
                  ? "topFilter" : ""}
                className={`dropdown_filter__list ${
                  this.props.fetchCurrentFacetSelection() === null &&
                  this.props.indexPro === 0
                    ? "dropdown_filter__list--active"
                    : this.state.active
                      ? "dropdown_filter__list--active"
                      : ""
                }`}
              >
                {this.props.RWDupdatedFilter.size<=0?<></>:
                  <div className="selected-facet-container">
                    <div className="selected-facet-wrapper">
                      {this.props.selectedFilter}
                      {this.state.RWDSelected.map((facet,key) =>(
                        <div className="selected-item">
                       {facet.label}
                       {/* <img className="crossImg" value={facet.value}
                        onClick={this.resolveRWDselectedFilter} 
                        src={crossIcon} alt="Close" /> */}
                       </div>
                        )
                      )}
                           
                    </div>
                    <hr />
                  </div>
                }
           
           
                {this.state.facetItem}

                {isMobile() && (
                  <>
                    <div className="clearfix" />

                    <div className="filterbtnWrapper">
                      <button
                        onClick={() => this.onCancelBtnClick()}
                        className="dropdown_filter__cancelBtn btn"
                        style={{ zIndex: 9999999999 }}
                      >
                        CANCEL
                      </button>
                      <button
                        onClick={() => {this.onApplyBtnClick(); this.onCancelBtnClick()}}
                        className="dropdown_filter__applyBtn btn"
                      >
                        APPLY
                      </button>
                    </div>
                  </>
                )}
              </ul>
            </div>
          )}
          {/* <hr /> */}
        </div>
      </>
    );
  }
}

/* ----------------------------------------   REDUX HANDLERS   -------------------------------------  */
const mapDispatchToProps = dispatch => {
  if (isMobile()) {
    return {
      onRWDFilterUpdate: (RWDupdatedArr, RWDfacetName, isApply) =>
        dispatch(
          actionCreators.RWDFilter(RWDupdatedArr, RWDfacetName, isApply)
        ),
      onRWDFilterCancel: () => dispatch(actionCreators.cancelRWDFilters()),
      onResetCurrentlFilter: () =>
        dispatch(actionCreators.resetCurentFilterSelection()),
    };
  } 
  return {
    onFilterUpdate: (updatedArr, facetName) =>
      dispatch(actionCreators.filter(updatedArr, facetName)),
  };
  
};

const mapStateToProps = state => {
  const stateObj = getReleventReduxState(state, "plpContainer");
  return {
    updatedFilter: stateObj.updateFilter,
    RWDupdatedFilter: stateObj.rwdUpdatedFilter,
    resetCurrentSelection: stateObj.resetCurrentSelection,
  };
};

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps
);

const withReducer = injectReducer({ key: "plpContainer", reducer });
const withSaga = injectSaga({ key: "plpContainer", saga });

export default compose(
  withReducer,
  withSaga,
  withConnect,
  withRouter
)(Filter);
